import React, { useEffect, useCallback, useState} from 'react';
import {TOGGLE, BANG, NUMBER} from 'zobject/data-types.js';

export const useZObjects = (subSequence) => {
    const createSequencer = useCallback((x,y) => {
        let sequencer = subSequence.createSequencer();
        sequencer.x = x;
        sequencer.y = y;
    }, [subSequence]);

    const createZObject= useCallback((x,y,type) => {
        subSequence.createZObject(x,y, type);
    }, [subSequence]);

    const createZMessage = useCallback((x,y) => {
        subSequence.createZMessage(x,y);
    }, [subSequence]);

    const createZNumber = useCallback((x,y) => {
        subSequence.createZMessage(x,y, NUMBER);
    }, [subSequence]);

    const createToggle = useCallback((x,y) => {
        subSequence.createZObject(x,y, "toggle");
    }, [subSequence]);

    const createButton = useCallback((x,y) => {
        subSequence.createZMessage(x,y, BANG);
    }, [subSequence]);

    const createPad = useCallback((x,y) => {
        let pad = subSequence.createPad();
        pad.x = x;
        pad.y = y;
    }, [subSequence]);

    return {
        createPad,
        createSequencer,
        createButton,
        createToggle,
        createZNumber,
        createZMessage,
        createZObject
    };
};
